import {
  getStoredMobile,
  getStoredOtpId,
  getStoredPendingEmailOtp,
  getStoredPendingPhoneOtp
} from '@/config/sourceStorage'

export const OTP_PREREQUISITE_KIND = {
  PHONE: 'phone',
  EMAIL: 'email'
}

export function getPhoneOtpPrerequisiteState() {
  const mobile = getStoredMobile()
  const pendingMobile = getStoredPendingPhoneOtp()
  const otpId = getStoredOtpId()
  const hasMobile = Boolean(mobile)
  const hasPendingMobile = Boolean(pendingMobile)
  const mobileMatchesPending = hasMobile && hasPendingMobile && pendingMobile === mobile

  return {
    mobile,
    pendingMobile,
    otpId,
    hasMobile,
    hasPendingMobile,
    hasOtpId: Boolean(otpId),
    mobileMatchesPending,
    isAllowed: mobileMatchesPending
  }
}

export function getEmailOtpPrerequisiteState(email) {
  const normalizedEmail = email?.trim() || ''
  const pendingEmail = getStoredPendingEmailOtp()
  const otpId = getStoredOtpId()
  const hasEmail = Boolean(normalizedEmail)
  const hasPendingEmail = Boolean(pendingEmail)
  const emailMatchesPending =
    hasEmail && hasPendingEmail && pendingEmail.toLowerCase() === normalizedEmail.toLowerCase()

  return {
    email: normalizedEmail,
    pendingEmail,
    otpId,
    hasEmail,
    hasPendingEmail,
    hasOtpId: Boolean(otpId),
    emailMatchesPending,
    isAllowed: hasEmail && emailMatchesPending
  }
}

export function getOtpPrerequisiteState(kind, email) {
  if (kind === OTP_PREREQUISITE_KIND.PHONE) {
    return getPhoneOtpPrerequisiteState()
  }

  return getEmailOtpPrerequisiteState(email)
}
